module.exports = __webpack_public_path__ + "static/media/golf7.1297fabc.jpg";